import Consts from './consts'

export const registerEmail = {
  subject: `【${Consts.ServiceName}】新規アカウント登録`,
  message: `<!doctype html>
<html>
<head>
  <meta charset="utf-8">
</head>
<body>
新規アカウント登録ありがとうございます。<br/>
「${Consts.ServiceName}」検証コードをお知らせします。<br/>
こちらの検証コードを入力してください。
<br/>
<br/>
検証コード：{####}<br/>
<br/>
<br/>
--------<br/>
本メールは${Consts.ServiceName}より送信されています。返信はできません。<br/>
</body>
</html>`,
}

export const resetPasswordEmail = {
  subject: `【${Consts.ServiceName}】パスワード再設定`,
  message: `<!doctype html>
<html>
<head>
  <meta charset="utf-8">
</head>
<body>
「${Consts.ServiceName}」検証コードをお知らせします。<br/>
こちらの検証コードを入力してパスワードの再設定を行ってください。<br/>
<br/>
<br/>
検証コード：{####}<br/>
<br/>
<br/>
--------<br/>
本メールは${Consts.ServiceName}より送信されています。返信はできません。<br/>
</body>
</html>`,
}

export const updateMailAddressEmail = {
  subject: `【${Consts.ServiceName}】メールアドレス変更`,
  message: `<!doctype html>
<html>
<head>
  <meta charset="utf-8">
</head>
<body>
メールアドレス変更のための検証コードをお知らせします。<br/>
こちらの検証コードを入力してください。
<br/>
<br/>
検証コード：{####}<br/>
<br/>
<br/>
--------<br/>
本メールは${Consts.ServiceName}より送信されています。返信はできません。<br/>
</body>
</html>`,
}
